import { Color } from 'csstype'
import React from 'react'
import { CidadaoListagemHipertensaoQueryModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'

import { AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection } from '../AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection'
import { AcompanhamentoCondicaoSaudeAcompanhamentoHipertensaoSection } from './AcompanhamentoCondicaoSaudeAcompanhamentoHipertensaoSection'

interface AcompanhamentoCondicaoSaudeHipertensaoAccordionPanelProps {
  row: CidadaoListagemHipertensaoQueryModel
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeHipertensaoAccordionPanel({
  row,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeHipertensaoAccordionPanelProps>) {
  return (
    <>
      <AcompanhamentoCondicaoSaudeAcompanhamentoHipertensaoSection
        dataUltimaConsulta={row?.hipertensao?.dataUltimaConsulta}
        qtdMedicoesPressaoArterial={row?.hipertensao?.qtdMedicoesPressaoArterial}
        qtdConsultas={row?.hipertensao?.qtdConsultas}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection
        dataUltimasVisitasDomiciliares={row?.hipertensao?.visitasDomiciliaresReportDto?.dataUltimasVisitasDomiciliares}
        qtdVisitasDomiciliares={row?.hipertensao?.visitasDomiciliaresReportDto?.qtdVisitasDomiciliares}
        iconColor={iconColor}
      />
    </>
  )
}
